export default __webpack_public_path__ + "static/media/LBN.d80e1042.svg";